var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDownSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(2 -5.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-ios-downward",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6485",
    "data-name": "Rectangle 6485",
    width: 25,
    height: 25,
    transform: "translate(0 5.475)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239616",
    "data-name": "Path 239616",
    d: "M11.822,16.787a.9.9,0,0,1-.624-.256L5.351,10.969A1.225,1.225,0,0,1,5.224,9.4.9.9,0,0,1,6.6,9.256l5.224,4.983,5.224-4.805a.893.893,0,0,1,.717-.243.949.949,0,0,1,.657.409,1.217,1.217,0,0,1,.242.846,1.159,1.159,0,0,1-.379.778L12.436,16.6a.886.886,0,0,1-.614.189Z",
    transform: "translate(0.562 2.92)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownSvg);
export default __webpack_public_path__ + "static/media/caret-down-svg.21794fb1afda026472669c9808d883ea.svg";
export { ForwardRef as ReactComponent };